import gql from 'graphql-tag';

export default gql`
  query getCurrencies($portfolioId: ID!) {
    currencies: getCurrencies(portfolioId: $portfolioId) {
      id
      name
      symbol
      type
      expiry
    }
  }
`;
